export const CAPTURE_OPERATION_MODES = {
    QR: 'qr',
    VIDEO_SELFIE: 'video-selfie',
};

export const CAPTURE_OPERATION_VIDEO_SELFIE_MODE = [CAPTURE_OPERATION_MODES.QR, CAPTURE_OPERATION_MODES.VIDEO_SELFIE];

export const VIDEO_SELFIE_CAPTURE_VIEW_PATH = 'capture/video-selfie';
